import React from "react"
import { ErrorBoundary as ReactErrorBoundary } from "react-error-boundary"
import ErrorPage from "../Error/component"

interface ErrorBoundaryProps {
  children: React.ReactNode
}

const ErrorBoundary: React.FC<ErrorBoundaryProps> = ({ children }) => {
  const handleError = (error: Error, info: { componentStack: string }) => {
    console.error("Error caught by boundary:", error, info)
  }

  const handleReset = () => {
    // Navigate to home page
    window.location.href = "/"
  }

  return (
    <ReactErrorBoundary
      fallback={
        <ErrorPage
          match={{
            params: {
              code: "500",
            },
          }}
          removeSidebar={() => {}}
          onReset={handleReset}
        />
      }
      onError={handleError}
    >
      {children}
    </ReactErrorBoundary>
  )
}

export default ErrorBoundary
